<template>
    <main class="relative">
        <Toaster />
        <div
            class="sm:overflow-y-hidden 2xl:px-[100px] relative mx-auto max-w-[1540px] overflow-x-hidden"
        >
            <div
                class="lg:flex 2xl:right-[107px] absolute top-[7px] right-[7px] z-[1] hidden justify-center"
            >
                <img
                    width="500"
                    height="500"
                    src="https://zaptime.s3.eu-central-1.amazonaws.com/application-assets/base-glass.png"
                    alt=""
                />
            </div>
            <div
                class="2xl:right-[-110px] absolute top-[-40px] right-[-220px] flex justify-center"
            >
                <GradientBackground></GradientBackground>
            </div>

            <ConfirmDialog></ConfirmDialog>
            <ProDialog></ProDialog>
            <div class="sm:grid sm:grid-cols-[248px_1fr] bg-[#F4F4F5]">
                <!-- Left Navigation Menu -->
                <nav class="sm:block z-40 hidden">
                    <div class="px-6">
                        <div class="flex h-screen flex-col justify-between">
                            <div>
                                <!-- Logo -->
                                <div
                                    class="mt-[38px] flex flex-shrink-0 items-center"
                                >
                                    <Link :href="route('app.dashboard')">
                                        <jet-application-mark
                                            class="h-9 block w-auto"
                                        />
                                    </Link>
                                </div>

                                <!-- Navigation Links -->
                                <div class="mt-10">
                                    <Link
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            isBookingsActive
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.dashboard')"
                                    >
                                        <BookingsIcon />
                                        {{ $t("nav.bookings") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            route().current(
                                                'app.event-types.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.event-types.index')"
                                    >
                                        <EventsIcon />
                                        {{ $t("nav.event_types") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            route().current(
                                                'app.appearances.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.appearances.index')"
                                    >
                                        <AppearanceIcon />
                                        {{ $t("nav.appearances") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            route().current(
                                                'app.availabilities.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="
                                            route('app.availabilities.index')
                                        "
                                    >
                                        <Clock :size="20" stroke-width="2.2" />
                                        {{ $t("nav.availability") }}
                                    </Link>

                                    <Link
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            route().current(
                                                'app.workflows.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="route('app.workflows.index')"
                                    >
                                        <Waypoints :size="20" />
                                        {{ $t("nav.workflows") }}
                                    </Link>

                                    <Link
                                        v-if="firstTeamId !== null"
                                        :class="[
                                            'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                            route().current(
                                                'app.teams.reports.index',
                                            )
                                                ? 'bg-iron-200 text-iron-700'
                                                : 'text-iron-500',
                                        ]"
                                        :href="
                                            route('app.teams.reports.index', {
                                                team: firstTeamId,
                                            })
                                        "
                                    >
                                        <ChartColumnStacked :size="20" />
                                        {{ $t("nav.team_reports") }}
                                    </Link>
                                </div>
                            </div>

                            <div class="pb-[30px]">
                                <Link
                                    v-if="page.props.pendingInvitation"
                                    class="h-10 gap-2 rounded-lg pl-3 text-xs font-medium text-iron-500 hover:bg-iron-200 inline-flex w-[200px] cursor-pointer items-center"
                                    :href="route('app.teams.index')"
                                >
                                    <div
                                        class="flex items-center justify-center"
                                    >
                                        <span
                                            class="h-2 w-2 rounded bg-purple-500"
                                        ></span>
                                        <span
                                            class="h-2 w-2 animate-ping rounded bg-purple-500 absolute"
                                        ></span>
                                    </div>
                                    {{ $t("teams.pending") }}
                                </Link>

                                <div
                                    v-for="invitation of page.props
                                        .pendingInvitations"
                                    class="mb-6 rounded-xl bg-white pt-3 shadow-sm relative"
                                >
                                    <div class="absolute z-10">
                                        <span
                                            class="-right-7 -top-4 h-3 w-3 bg-purple-500 absolute rounded-full"
                                        ></span>
                                        <span
                                            class="-right-7 -top-4 h-3 w-3 animate-ping bg-purple-500 absolute rounded-full"
                                        ></span>
                                    </div>

                                    <div class="px-4 pb-2">
                                        <p
                                            class="text-sm font-medium text-iron-700"
                                        >
                                            {{
                                                $t(
                                                    "teams.team_invitation.title",
                                                )
                                            }}
                                        </p>

                                        <p
                                            class="mt-1 text-sm tracking-tight text-iron-700"
                                        >
                                            {{
                                                $t(
                                                    "teams.team_invitation.description",
                                                    {
                                                        name: "Natali Craig",
                                                        team: invitation.team
                                                            .name,
                                                        role: capitalize(
                                                            invitation.role,
                                                        ),
                                                    },
                                                )
                                            }}
                                        </p>
                                    </div>

                                    <div
                                        class="border-iron-200 px-4 py-2 flex justify-between border-t"
                                    >
                                        <button
                                            @click="
                                                declineInvitation(invitation.id)
                                            "
                                            class="text-sm font-medium text-z-primary-600"
                                        >
                                            {{
                                                $t(
                                                    "teams.team_invitation.dismiss",
                                                )
                                            }}
                                        </button>

                                        <button
                                            @click="
                                                acceptInvitation(invitation.id)
                                            "
                                            class="gap-1 text-sm font-medium text-z-primary-600 flex"
                                        >
                                            <Check :size="20" />
                                            {{
                                                $t("teams.team_invitation.join")
                                            }}
                                        </button>
                                    </div>
                                </div>

                                <Link
                                    :class="[
                                        'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                        route().current('app.checklist.index')
                                            ? 'bg-iron-200 text-iron-700'
                                            : 'text-iron-500',
                                    ]"
                                    :href="route('app.checklist.index')"
                                >
                                    <Rocket :size="20" stroke-width="2.2" />
                                    {{ $t("nav.get_started") }}
                                </Link>

                                <Link
                                    :class="[
                                        'mb-4 h-10 gap-2 rounded-lg pl-3 font-medium hover:bg-iron-200 inline-flex w-[200px] items-center text-[15px]',
                                        route().current(
                                            'app.event-type-groups.*',
                                        )
                                            ? 'bg-iron-200 text-iron-700'
                                            : 'text-iron-500',
                                    ]"
                                    :href="route('app.event-type-groups.show')"
                                >
                                    <LayoutPanelTop :size="20" />
                                    {{ $t("nav.my_page") }}
                                </Link>

                                <ProfileSettingsDropdown></ProfileSettingsDropdown>
                            </div>
                        </div>
                    </div>
                </nav>

                <!-- Page Content -->

                <main
                    class="page-content mr-0 mt-1.5 rounded-t-xl sm:mr-4 sm:mt-4 relative z-20"
                >
                    <div
                        class="gap-2 rounded-t-xl bg-white px-4 sm:h-[88px] sm:gap-4 sm:px-6 flex h-[64px] items-center border-b"
                    >
                        <div>
                            <slot name="icon"></slot>
                        </div>
                        <div class="grow">
                            <h1
                                class="text-lg font-semibold leading-6 tracking-tight text-iron-900 sm:text-xl"
                            >
                                <slot name="title"></slot>
                            </h1>
                            <p class="text-sm text-iron-500 sm:block hidden">
                                <slot name="description"></slot>
                            </p>
                        </div>
                        <div
                            class="gap-3 sm:justify-center flex items-center justify-end"
                        >
                            <slot name="actions"></slot>
                        </div>
                    </div>

                    <!-- <div
                        class="items-center gap-4 rounded-t-xl border-b bg-white px-4 sm:hidden"
                    >
                        <div>
                            <slot name="icon"></slot>
                        </div>
                        <div class="grow">
                            <h1
                                class="text-lg font-semibold leading-6 tracking-tight text-iron-900 sm:text-xl"
                            >
                                <slot name="title"></slot>
                            </h1>
                            <p class="text-sm text-iron-500">
                                <slot name="description"></slot>
                            </p>
                        </div>
                        <div
                            class="flex items-center justify-end gap-3 sm:justify-center"
                        >
                            <slot name="actions"></slot>
                        </div>
                    </div> -->
                    <div class="bg-iron-25">
                        <ScrollArea
                            class="sm:h-[calc(100vh-120px)] h-[calc(100vh-144px)]"
                        >
                            <slot></slot>
                        </ScrollArea>
                    </div>
                </main>

                <!-- Mobile Bottom fixed Menu -->
                <div
                    class="bottom-0 left-0 border-iron-200 bg-white px-4 py-4 sm:hidden fixed z-50 flex w-full items-center border-t"
                >
                    <ProfileSettingsDropdown></ProfileSettingsDropdown>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
import JetApplicationMark from "../Jetstream/ApplicationMark.vue";
import ProfileSettingsDropdown from "./components/ProfileSettingsDropdown.vue";
import ConfirmDialog from "../Pages/Zaptime/App/ConfirmDialog/components/ConfirmDialog.vue";
import route from "ziggy-js";
import { Link, usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import GradientBackground from "./GradientBackgroud.vue";
import BookingsIcon from "./components/BookingsIcon.vue";
import EventsIcon from "./components/EventsIcon.vue";
import AppearanceIcon from "@/Layouts/components/AppearanceIcon.vue";

import { ScrollArea } from "@/components/ui/scroll-area";

import {
    Waypoints,
    Clock,
    ChartColumnStacked,
    Check,
    LayoutPanelTop,
    Rocket,
} from "lucide-vue-next";
import ProDialog from "@/ProModal/components/ProDialog.vue";
import Toaster from "../components/ui/toast/Toaster.vue";
import useConfirm from "../Pages/Zaptime/App/ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { TeamInvitation } from "@/Pages/Zaptime/App/Teams/types/Team";
import { capitalize } from "../utils/capitalize";
import PaidFeatureIcon from "../Pages/Zaptime/App/Atomic/PaidFeatureIcon.vue";
import { useHasSubscription } from "@/composables/useHasSubscription";

const { show } = useConfirm();
const { hasSubscription } = useHasSubscription();
const { t } = useI18n();

const isBookingsActive = computed(() => {
    return (
        route().current("app.dashboard") ||
        route().current("app.dashboard.upcoming") ||
        route().current("app.dashboard.cancelled") ||
        route().current("app.dashboard.past")
    );
});

type SharedData = {
    pendingInvitations: TeamInvitation[];
};
const page = usePage<SharedData>();

const firstTeamId = computed(() => {
    // @ts-expect-error
    const currentUserId = page.props.user.id;

    // @ts-expect-error
    const ownedTeams = page.props.allTeams.filter((team) => {
        return team.owner?.id === currentUserId;
    });

    let teamId: number | null = null;

    for (const team of ownedTeams) {
        if (!team.personal_team) {
            teamId = team.id;
            break;
        }
    }

    return teamId;
});

async function acceptInvitation(invitationId: number) {
    router.post(
        route("app.teams.invitations.accept", {
            invitation: invitationId,
        }),
    );
}

async function declineInvitation(invitationId: number) {
    const success = await show({
        header: t("teams.invite_card.decline_confirmation_title"),
        message: t("teams.invite_card.decline_confirmation_description"),
        cancel: t("teams.invite_card.decline_confirmation_action"),
    });

    if (success) {
        router.delete(
            route("app.teams.invitations.decline", {
                invitation: invitationId,
            }),
        );
    }
}
</script>

<style>
.page-content {
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 0px 10px rgba(16, 24, 40, 0.08);
}
</style>
